document.addEventListener("DOMContentLoaded", function() {
  const logoList = document.querySelectorAll('.logoList--item');
  const logoListContent = document.querySelectorAll('.logoList-content__item');

  logoList.forEach((logoItem) => {
    logoItem.addEventListener('click', (event) => {
      if (event.currentTarget.classList.contains('active') === false) {
        logoList.forEach((logoItem) => {
          logoItem.classList.remove('active');
        })
        event.currentTarget.classList.add('active');
        const logoItemContent = document.querySelector(`[data-parent-block-id='${event.currentTarget.dataset.blockId}']`);
        logoListContent.forEach((logoContent) => {
          logoContent.classList.remove('active');
        })
        logoItemContent.classList.add('active');
      } else {
        event.currentTarget.classList.remove('active');
      }
    });
  });
});